import { all, put, takeLatest } from 'redux-saga/effects';

import { types as statesTypes } from '../ducks/states';

export function * watchStates() {
    yield takeLatest(statesTypes.STATES_GET, onStatesGet);
    yield takeLatest(statesTypes.STATES_SUCCESS, onStatesGetResponse);
}

export function * onStatesGet({ payload }) {
    payload.method = 'get';
    return yield payload;
}

export function * onStatesGetResponse({ response, payload }) {
    if (payload.action === 'get' && response && payload.dataset === 'states') {
        return yield all([
            put({
                type: statesTypes.STATES_SET,
                payload: response,
            }),
        ]);
    }
}
